<template>
    <v-snackbar v-model="snackbar" :timeout="-1" multi-line color="#333" rounded="xl" bottom>
        <span class="mr-3"><v-icon x-large :color="color">{{ icon }}</v-icon></span>
        <div class="headline font-weight-bold">{{ message }}</div>
    </v-snackbar>
</template>

<script>
export default {
	name: 'Snackbar',
	data: () => ({
        snackbar    : false,
        message     : '',
        status      : '',
        timeout     : null,
	}),
	mounted() {
        /** 
         *  snackbar event listener
         *  @param {Object} snackbar - snackbar obj
         */
        this.$root.$on('snackbar', ({status, message}) => {
            this.message = message
            this.status = status
            this.snackbar = true
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => { this.snackbar = false }, 4000)
        })

    },
    beforeDestroy() { this.$root.$off('snackbar') },
	computed: {
        /** 
         *  snackbar icon
         *  @return {String} - icon for status
        */
        icon()  {
            switch (this.status) {
                case 'success'      : return 'mdi-check-circle'
                case 'error'        : return 'mdi-close-circle'
                default             : return 'mdi-exclamation-circle';
            } 
        },
        /** 
         *  snackbar color
         *  @return {String} - color for status
        */
        color() {
            switch (this.status) {
                case 'clock-in'     :
                case 'success'      : return 'success'
                case 'error'        : return 'error'
                default             : return 'orange';
            }
        }
	}
}
</script>